import I18n from 'I18n';
import { InlineLabel } from 'foundations-components/transitional/components/InlineLabel';
import { MicroDateRange } from 'foundations-components/transitional/components/MicroDateRange';
import { useGetQueryParam } from '../../../app/hooks/useGetQueryParam';
import { useSetQueryParams } from '../../../app/hooks/useSetQueryParams';
import { DateFilterPresets, dateStringToSimpleDate, simpleDateToDateString } from '../../../app/utils/dateUtils';
import { useDateFieldForCategory } from '../../hooks/useDateFieldForCategory';
import { useParams } from 'react-router-dom';
import { TrackingAction, TrackingFeature, TrackingScreen, trackUsage } from '../../../app/utils/tracking';
import { getTrackingSubscreenTab } from '../../utils';
import { jsx as _jsx } from "react/jsx-runtime";
export default function ProductUpdatesDateFilter({
  min
}) {
  const endDateFromQs = useGetQueryParam('endDate');
  const startDateFromQs = useGetQueryParam('startDate');
  const {
    category
  } = useParams();
  const dateField = useDateFieldForCategory();
  const value = {
    startDate: startDateFromQs ? dateStringToSimpleDate(startDateFromQs) : null,
    endDate: endDateFromQs ? dateStringToSimpleDate(endDateFromQs) : null
  };
  const setQueryParams = useSetQueryParams();
  if (category === 'recommended' || category === 'scheduled-for-release') {
    return null;
  }
  return /*#__PURE__*/_jsx(InlineLabel, {
    label: `${I18n.text(`app.filters.${dateField}`)}:`,
    marginBlock: "100",
    children: /*#__PURE__*/_jsx(MicroDateRange, {
      min: min,
      onChange: evt => {
        const {
          startDate,
          endDate
        } = evt.target.value;
        setQueryParams({
          endDate: endDate ? simpleDateToDateString(endDate) : '',
          startDate: startDate ? simpleDateToDateString(startDate) : '',
          offset: ''
        });
        trackUsage(TrackingScreen.PRODUCT_UPDATES, getTrackingSubscreenTab(category), TrackingFeature.DATE_FILTER, TrackingAction.CLICK);
      },
      value: value,
      presets: DateFilterPresets.past,
      showPresets: true
    })
  });
}